export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Eroare la inițializare",
    "StaticConfigLoader.caption.init": "Inițializare",
    "StaticConfigLoader.text.init": "Se inițializează aplicația...",
    "StaticConfigLoader.error.settings": "Nu se pot încărca setările site-ului",
    "StaticConfigLoader.error.circuits": "Nu se poate încărca configurația serviciilor",
    //app
    "Legal.Localization": "ro",
    "AchievementApp.Navbar.storeTitle": "Store",
    "AchievementApp.Navbar.supportTitle": "Support",
    "Legal.TermsConditions": "Terms and Conditions",
    "Legal.TermsService": "Terms of Service",
    "Legal.PrivacyPolicy": "Privacy Policy",
    "Legal.CookiesPolicy": "Setări cookie",
    "Legal.Copyright": "All trademarks, logos and brand names are the property of their respective owners.",
    "AchievementApp.Navbar.achievement": "Realizări personale",
    "AchievementApp.Navbar.userAchievement": "Realizări utilizator",
    "AchievementApp.Navbar.settingsLink": "Setări",
    "AchievementApp.Navbar.profileLink": "Profil",
    "AchievementApp.Navbar.reloginLink": "Conectează-te din nou sau schimbă contul",
    "AchievementApp.Navbar.pageTitlePrew": "Realizări ",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Finalizată",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Filtrează în funcție de titlurile",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Prietenii mei",
    "UserFriendsList.heading.showMore": "Afișează mai multe",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Trebuie să configurezi autorizarea cu doi factori",
    "LimitedAccountPanel.2step.link": "Mai multe despre autorizarea cu doi factori",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Trebuie să îți confirmi adresa de e-mail",
    "LimitedAccountPanel.email.link": "Continuare spre profil",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Contul tău este limitat datorită:",
    "LimitedAccountPanel.conclusion": "După modificarea setărilor de securitate, trebuie să te deconectezi și să te conectezi din nou pentru ca modificările să fie aplicate",
    "LimitedAccountPanel.relogin": "Conectează-te din nou",
    "EmailVerificationStateIcon.success": "Cont confirmat, e-mail verificat",
    "EmailVerificationStateIcon.warning": "Cont neconfirmat, e-mail neverificat",
    "EmailVerificationStateIcon.danger": "Cont neconfirmat, ESTE NECESARĂ verificarea e-mailului",
    "TwoFactorStateIcon.success": "Cont securizat prin autorizare cu doi factori",
    "TwoFactorStateIcon.warning": "Cont nesecurizat, autorizare cu doi factori dezactivată",
    "TwoFactorStateIcon.danger": "ESTE NECESARĂ autorizarea cu doi factori",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Salvează setările",
    "UserSettingDialog.settings": "Setări",
    "UserSettingDialog.userSettings": "Setări utilizatori",
    "UserSettingDialog.language": "Limbă",
    "UserSettingDialog.privacy": "Confidențialitate",
    "UserSettingDialog.allUsers": "Toți utilizatorii",
    "UserSettingDialog.friendsOnly": "Numai prietenii",
    "UserSettingDialog.onlyMe": "Numai eu",
    "UserSettingDialog.whoCanView": "Cine poate vedea realizările mele",
    //unlockProgress
    "ViewUnlockProgress.of": " din ",
    "ViewUnlockProgress.achievCompleted": " realizări finalizate",
    "ViewUnlockProgress.myUnlock": "Realizările mele",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Caută poreclă aici",
    "ViewItemSearch.label.search": "Caută utilizatori",
    "ViewItemSearch.resultNotFound": "Utilizatorul nu a fost găsit",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Realizare",
    "ViewItemSearch.stub.empty": "Nicio realizare",
    "ViewItemSearch.stub.emptyCompare_1": "Utilizatorul ",
    "ViewItemSearch.stub.emptyCompare_2": " nu are nicio realizare în acest joc",
    "ViewItemSearch.limitedAccess": "Accesul la realizările utilizatorului selectat este limitat",
    "ViewItemSearch.heading.selectGame": "Selectează jocul din listă",
    "ViewItemSearch.globalstat.opened": "deblocată de ",
    "ViewItemSearch.globalstat.ofGamers": "% dintre jucători",
    //authentication
    "NotAllowedMessage.caption": "Nu este permis",
    "NotAllowedMessage.body.h1": "Accesul la realizări",
    "NotAllowedMessage.body.h3": "nu este permis momentan pentru contul tău",
    "NotAllowedMessage.relogin": "Schimbă contul",
    "LandingMessage.caption": "Autentificare",
    "LandingMessage.body": "Se finalizează încărcarea...",
    "TokenExpiredMessage.caption": "Autentificarea a expirat",
    "TokenExpiredMessage.body.h3": "Nu putem face prea multe cu asta, dar poți totuși",
    "TokenExpiredMessage.relogin": "Conectează-te din nou",
    "AuthErrorMessage.caption": "Autentificarea a eșuat",
    "AuthErrorMessage.body.h1": "Autentificarea nu a putut fi verificată",
    "AuthErrorMessage.body.code": "Cod",
    "AuthErrorMessage.body.desc": "Nu putem face prea multe cu asta, dar poți totuși",
    "AuthErrorMessage.relogin": "Reconecta",
    "AuthorizationRequiredMessage.caption": "Se solicită autentificarea",
    "AuthorizationRequiredMessage.body.h3.1": "Ești pe punctul de a accesa",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Dar trebuie să fii autorizat pentru a merge mai departe",
    "AuthorizationRequiredMessage.login": "Conectează-te cu Gaijin.Net",
    "CheckingAuthMessage.caption": "Autentificare",
    "CheckingAuthMessage.body": "Se verifică autentificarea, te rugăm să ai răbdare",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Versiunea pentru mobil este temporar indisponibilă",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Folosește versiunea pentru computer",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Ne cerem scuze",
}